module.exports = __webpack_public_path__ + "img/ljyy.5d159e2a.png";